import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import size from 'lodash/size';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import Avatar from 'shared/components/Avatar';

import styles from './styles';
import messages from './messages';

import ChatTypingIndicator from '../../messages/ChatTypingIndicator';
import { selectArticlesList, getCompanyAvatarUrl, selectArticlesFetching } from '../../../app/ChatApp/selectors';
import { handleFetchArticles, incrementKbArticleVisited } from '../../../app/ChatApp/actions';

export class ChatMessageArticleList extends PureComponent {
  componentDidMount() {
    const { fetchArticles, message } = this.props;

    fetchArticles(get(message, 'query'));
  }
  componentDidUpdate() {
    const { fetching, articles, onHandleResponse } = this.props;

    if (!fetching && articles && !articles.length) {
      onHandleResponse({ skip: true });
    }
  }
  handleClick = article => {
    const { onSelectArticle, incrementVisited } = this.props;
    onSelectArticle(article);
    incrementVisited(article.id);
  };
  renderResults() {
    const { articles } = this.props;

    return (
      <ul style={styles.listContainer}>
        {articles.map(article => {
          return (
            <div key={article.id} className="userMessage kustomer-app-thread-user-message" style={styles.message}>
              <li style={styles.articleItem} onClick={() => this.handleClick(article)}>
                <div>
                  <div style={styles.icon} />
                </div>
                <span style={styles.title}>{article.title}</span>
              </li>
            </div>
          );
        })}
      </ul>
    );
  }

  renderResultsMessage() {
    const { message, articles } = this.props;

    if (size(articles)) {
      return get(message, 'hasResults.displayValue');
    }

    return get(message, 'noResults.displayValue');
  }

  renderMessageColumn() {
    return (
      <div>
        <div className="articleListMessage kustomer-app-thread-article-list-message" style={styles.message}>
          <p>{this.renderResultsMessage()}</p>
        </div>
        {this.renderResults()}
      </div>
    );
  }

  renderAvatarColumn() {
    const { avatarUrl } = this.props;

    return (
      <div style={styles.userAvatar}>
        <Avatar includeDefault avatarUrl={avatarUrl} />
      </div>
    );
  }

  renderSatisfaction = () => {
    const { intl, articles, message } = this.props;

    if (!articles || !articles.length) return null;

    const followUpPrompt = get(message, 'followUpPrompt');

    return (
      <div style={styles.wrapper}>
        {this.renderAvatarColumn()}
        <p className="articleListMessage kustomer-app-thread-article-list-message" style={styles.message}>
          <span>{followUpPrompt || intl.formatMessage(messages.follow_up_prompt)}</span>
        </p>
      </div>
    );
  };
  render() {
    const { fetching } = this.props;

    if (fetching) {
      return <ChatTypingIndicator />;
    }

    return (
      <div>
        <div style={styles.wrapper}>
          {this.renderAvatarColumn()}
          {this.renderMessageColumn()}
        </div>
        {this.renderSatisfaction()}
      </div>
    );
  }
}

ChatMessageArticleList.propTypes = {
  articles: PropTypes.instanceOf(Array).isRequired,
  intl: intlShape.isRequired,
  message: PropTypes.instanceOf(PropTypes.object),
  avatarUrl: PropTypes.string,
  fetchArticles: PropTypes.func.isRequired,
  onSelectArticle: PropTypes.func.isRequired,
  onHandleResponse: PropTypes.func.isRequired,
  incrementVisited: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
};

ChatMessageArticleList.defaultProps = {
  articles: undefined,
  message: {},
  avatarUrl: null,
  fetching: false,
};

const mapStateToProps = () => {
  return state => ({
    articles: selectArticlesList(state),
    avatarUrl: getCompanyAvatarUrl(state),
    fetching: selectArticlesFetching(state),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    fetchArticles(query) {
      dispatch(handleFetchArticles(query));
    },
    incrementVisited(id) {
      dispatch(incrementKbArticleVisited(id));
    },
  };
};

export const intlChatMessageArticleList = injectIntl(ChatMessageArticleList);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(intlChatMessageArticleList);
